export default function buildResolvedFile(src) {
  if (!src) return { resolvedSrc: '', lastSrc: null, loaded: false };
  if (/^https?:\/\//i.test(src)) return { resolvedSrc: src, lastSrc: src, loaded: true };

  // Always use REACT_APP_BACKEND_URL from .env
  const envBase = process.env.REACT_APP_BACKEND_URL;
  const base = envBase ? envBase.replace(/\/$/, '') : '';
  const normalized = src.startsWith('/') ? src : `/${src}`;
  const resolved = `${base}${normalized}`;
  return { resolvedSrc: resolved, lastSrc: resolved, loaded: true };
}